module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_E_4.99892191.mp3";